import type { TemplateCategory, TemplateGroup } from "../businessReports.types";

const leadingSyntheticGroupLabels = new Set(["Favourites"]);

export const mergeTemplateCategoriesIntoGroups = (
  groups: TemplateGroup[],
  categories: TemplateCategory[],
): TemplateGroup[] => {
  if (categories.length === 0) return groups;

  const categoryGroups = new Map<string, TemplateGroup>();
  const leadingGroups: TemplateGroup[] = [];
  const trailingGroups: TemplateGroup[] = [];

  for (const group of groups) {
    if (group.categoryId) {
      categoryGroups.set(group.categoryId, group);
    } else if (leadingSyntheticGroupLabels.has(group.label)) {
      leadingGroups.push(group);
    } else {
      trailingGroups.push(group);
    }
  }

  const mergedCategoryGroups = categories.map(category => {
    const existingGroup = categoryGroups.get(category.id);
    if (!existingGroup) {
      return { label: category.name, categoryId: category.id, templates: [] };
    }
    if (existingGroup.label === category.name) return existingGroup;
    return { ...existingGroup, label: category.name };
  });

  const categoryIds = new Set(categories.map(category => category.id));
  for (const [categoryId, group] of categoryGroups.entries()) {
    if (!categoryIds.has(categoryId)) {
      mergedCategoryGroups.push(group);
    }
  }

  return [...leadingGroups, ...mergedCategoryGroups, ...trailingGroups];
};
